import * as React from "react";
import * as ReactDOM from "react-dom";
export interface FooterProps extends React.Props<FooterControl> {
}

export class FooterControl extends React.Component<FooterProps, any> {
    constructor(props: FooterProps) {
        super(props);
    }
       
    public render() : JSX.Element {
        return (
            <div className="outline footer">
            <ul>
                <li><a href="//aka.ms/bf-contactus">Contact us</a></li>
                <li><a href="//aka.ms/bf-privacy">Privacy & cookies</a></li>
                {this.props.children}
                <li>{"\u00a9 2016 Microsoft"}</li>
            </ul>
            </div>); 
    }
}  



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/FooterControl.tsx